module.exports = __webpack_public_path__ + "img/logo.a2ddd3e1.png";